export default function Logo({ variant = "header", className = "" }) {
  const src = variant === "large" ? "/logo-large.png" : "/logo.png";
  const height = variant === "large" ? "h-16 sm:h-20" : variant === "sm" ? "h-6" : "h-7 sm:h-8";
  return (
    <img
      src={src}
      alt="FreightPilot AI"
      data-testid="logo"
      className={`${height} w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
}
